function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { convertMoneyCurrency } from '~/utility/money';
export var useCurrencyStore = defineStore('currencyStore', () => {
  var _config$axios;
  var config = useRuntimeConfig();
  var baseURL = (_config$axios = config.axios) === null || _config$axios === void 0 ? void 0 : _config$axios.baseURL;
  var currencies = ref({});
  function load() {
    return _load.apply(this, arguments);
  }
  function _load() {
    _load = _asyncToGenerator(function* () {
      if (Object.keys(currencies.value).length) {
        return;
      }
      var url = '/_/fallback/_/currencies/';
      var resp = yield $fetch(url, {
        baseURL,
        timeout: 20000
      });
      var mapped = resp.reduce((mapped, currency) => {
        mapped[currency.code] = currency;
        return mapped;
      }, {});
      currencies.value = mapped;
      return mapped;
    });
    return _load.apply(this, arguments);
  }
  if (process.server) {
    onServerPrefetch( /*#__PURE__*/_asyncToGenerator(function* () {
      yield load();
    }));
  }
  onBeforeMount( /*#__PURE__*/_asyncToGenerator(function* () {
    yield load();
  }));
  function convert(priceToConvert, toCurrencyCode) {
    if (priceToConvert.getCurrency() === toCurrencyCode || !Object.keys(currencies.value).length) {
      return priceToConvert;
    }
    var fromCurrency = currencies.value[priceToConvert.getCurrency()];
    var toCurrency = currencies.value[toCurrencyCode];
    return convertMoneyCurrency(priceToConvert, fromCurrency, toCurrency);
  }
  return {
    convert,
    currencies,
    load
  };
});